import React from 'react'
import Header from "../inc/Header";
import { Link } from 'react-router-dom';
import "./About.css";

function About() {
  return (
    <div>
      <Header />
      <br />
      <br />
      <br />
      <br />
      <div className='Tehattafurniture'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">About us</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <br />
     
        <div className="colo">
          <div className="album py-1">
            <div className="container">
              <h3 ><b>About A2ZIndia – Your Vision, Our Design</b> </h3>
              <p className='justify mb-2'>At A2ZIndia, we believe that every space has a story, and our mission is to bring that story to life with creativity, precision, and elegance. As one of India’s leading interior design companies, we specialize in crafting inspiring residential, commercial, and turnkey interiors that blend functionality with style.</p>

              <p className='justify mb-2'>With years of experience and a team of passionate designers, architects, and project managers, we take pride in delivering tailor-made solutions that reflect our clients’ personalities and needs. From conceptualization to execution, our end-to-end services ensure a seamless transformation of spaces — on time and within budget.</p>

              <h6 className='justify'>What sets A2ZIndia apart is our commitment to quality, innovation, and customer satisfaction. Whether it’s a cozy home makeover or a large-scale corporate fit-out, we approach every project with the same level of dedication and attention to detail.</h6>
            </div>
            </div>
            </div>
         

          <br />
        </div>
        )
}

        export default About
